<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>放映厅列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!--搜素 添加 -->
    <el-form :inline="true" style="margin-top: 20px;">
      <el-form-item>
        <el-input size="small" v-model="name1" placeholder="请输入放映厅名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="categoryName1" placeholder="请输入分类名"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="chongzhi">重置</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="openShow()">添加</el-button>
      </el-form-item>
    </el-form>

    <!-- 列表 -->
    <el-table size="small" :data="ShowData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中"
      style="width: 100%;">
      <el-table-column align="center" sortable type="index" label="序号"></el-table-column>
      <el-table-column align="center" sortable prop="name" label="放映厅名称" width="120"></el-table-column>
      <el-table-column align="center" sortable prop="image" label="封面图" width="120">
        <template slot-scope="scope">
          <el-image v-if="scope.row.image" style="width: 90px;height: 90px;" :src="scope.row.image"
            :preview-src-list="[scope.row.image]" />
          <div v-if="scope.row.image == null">没有图片</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="categoryName" label="分类名" width="120"></el-table-column>
      <el-table-column align="center" sortable prop="score" label="评分" width="100"></el-table-column>
      <!-- <el-table-column align="center" sortable prop="amount" label="奖学金" width="100"></el-table-column> -->
      <el-table-column align="center" sortable prop="createTime" label="创建时间" width="160">
        <template slot-scope="scope">
          <div v-if="scope.row.createTime">{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="500">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="getRoomxq(scope.row)">查看放映厅详情</el-button>
          <el-button size="mini" type="primary" @click="openShow(scope.row)">修改</el-button>
          <el-button size="mini" type="danger" @click="deleShow(scope.row)">删除</el-button>
          <el-button size="mini" type="primary" @click="showToVideo(scope.row)">查看放映厅视频列表</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑界面 -->
    <el-dialog :title="tit" :visible.sync="editFormVisiible" width="40%">
      <el-form label-width="120px">
        <el-form-item label="放映厅名称" prop="name">
          <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入放映厅名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input size="small" v-model="description" auto-complete="off" placeholder="请输入放映厅描述"></el-input>
        </el-form-item>
        <el-form-item label="封面图">
          <div style="display: flex; align-items: center;">
            <el-upload action="" :http-request="mainImgUpload" :show-file-list="false" list-type="picture-card">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-image v-if="image" style="width: 140px;height: 140px;margin-left: 14px;" :src="image"
              :preview-src-list="[image]" />
          </div>
        </el-form-item>
        <el-form-item label="分类名" prop="categoryName">
          <el-input size="small" v-model="categoryName" auto-complete="off" placeholder="请输入分类名"></el-input>
        </el-form-item>
        <el-form-item label="评分" prop="score">
          <el-input-number size="small" max="10" min="0" v-model="score">
          </el-input-number>
        </el-form-item>
        <!-- <el-form-item label="奖学金" prop="amount">
          <el-input size="small" v-model="amount" auto-complete="off" placeholder="请输入金额"></el-input>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog()'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="addShow()" v-if="tit == '添加'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="upShow()" v-if="tit == '修改'">修改</el-button>
      </div>
    </el-dialog>

    <!-- 放映厅详情 -->
    <el-dialog title="放映厅详情页：" :visible.sync="editFormDetails">
      <el-form label-width="120px">
        <el-form-item label="放映厅名称：" prop="name">
          <span v-html="this.Details.name"></span>
        </el-form-item>
        <el-form-item label="放映厅描述：">
          <span v-html="this.Details.description" style="display: block; width: 100%"></span>
        </el-form-item>
        <el-form-item label="封面图：">
          <el-image v-if="this.Details.image" style="width: 140px;height: 140px;margin-left: 14px;"
            :src="this.Details.image" :preview-src-list="[this.Details.image]" />
        </el-form-item>
        <el-form-item label="分类名：" prop="categoryName">
          <span v-html="this.Details.categoryName"></span>
        </el-form-item>
        <el-form-item label="评分：" prop="score">
          <span v-html="this.Details.score"></span>
        </el-form-item>
        <!-- <el-form-item label="金额：" prop="amount">
          <span v-html="this.Details.amount"></span>
        </el-form-item> -->
        <el-form-item label="创建时间：" prop="createTime" v-if="this.Details.createTime">
          {{ transformDate(this.Details.createTime) }}
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import client from "@/utils/ossClient.js";
import Pagination from '../../components/Pagination'
import { getScreenRoomList } from '../../api/userMG'
import { getScreenRoomInfo } from '../../api/userMG'
import { addScreenRoom } from '../../api/userMG'
import { deleteScreenRoom } from '../../api/userMG'
import { upScreenRoom } from '../../api/userMG'
export default {
  data() {
    return {
      ShowData: [],
      editFormVisiible: false,
      name: '',
      description: '',
      image: '',
      categoryName: '',
      score: '',
      amount: '',
      Details: [],
      editFormDetails: false,
      loading: false,
      tit: '添加',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      },
      name1: '',
      categoryName1: ''
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  created() {
    this.getShow(1);
  },
  methods: {
    // 分页插件事件
    callFather(parm) {
      this.pageparm.page = parm.currentPage
      this.getShow(parm.currentPage)
    },
    // 搜索事件
    search() {
      this.getShow(1)
    },
    // 重置数据
    chongzhi() {
      this.name1 = ''
      this.categoryName1 = ''
      this.getShow(1)
    },
    // 跳转页面
    showToVideo(row) {
      setTimeout(() => {
        this.loading = false
        // 跳转页面
        this.$router.push({
          path: '/Video', query: {
            id: row.id,
            name: row.name
          }
        })
      })
    },
    // 关闭编辑对话框
    closeDialog() {
      this.editFormVisiible = false
      this.$message({
        type: 'info',
        message: '已取消编辑'
      })
    },
    // 查看详情页面
    getRoomxq(row) {
      this.loading = true;
      this.editFormDetails = true;
      let data = {
        id: row.id
      }
      getScreenRoomInfo(data).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$Message({
            type: "info",
            message: res.msg
          });
        } else {
          this.Details = res.data.data;
          return;
        }
      })
    },
    // 删除
    deleShow(row) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(() => {
        let data = {
          id: row.id
        }
        deleteScreenRoom(data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.getShow(1)
          } else {
            this.$message.error(res.msg);
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 修改
    upShow() {
      this.loading = true,
        upScreenRoom({
          id: this.id,
          name: this.name,
          description: this.description,
          image: this.image,
          categoryName: this.categoryName,
          score: this.score,
          // amount: this.amount,
        }).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success(res.msg)
            this.editFormVisiible = false
            this.getShow(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg)
          }
        })
    },
    // 添加
    addShow() {
      this.loading = true,
        addScreenRoom({
          name: this.name,
          description: this.description,
          image: this.image,
          categoryName: this.categoryName,
          score: this.score,
          // amount: this.amount
        }).then((res) => {
          if (res.code == 200) {
            this.loading = false
            this.$message.success(res.msg)
            this.editFormVisiible = false
            this.getShow(1)
          } else {
            this.editFormVisiible = false
            this.$message.error(res.msg)
          }
        })
    },
    // 自定义上传方法
    mainImgUpload(file) {
      // 判断扩展名
      const tmpcnt = file.file.name.lastIndexOf(".");
      const exname = file.file.name.substring(tmpcnt + 1);
      const names = ["jpg", "jpeg", "webp", "png", "bmp"];
      if (names.indexOf(exname) < 0) {
        this.$message.error("不支持的格式!");
        return;
      }
      const fileName = file.file.uid + "." + exname;
      client
        .put(fileName, file.file)
        .then((res) => {
          if (res.url) {
            this.image = res.url
            // this.image.push(res.url)
          } else {
            this.$message.error("文件上传失败");
          }
        })
        .catch((err) => { });
    },
    // 打开编辑器
    openShow(row) {
      this.editFormVisiible = true;
      if (row != undefined && row != "undefined") {
        this.tit = "修改";

        this.id = row.id;
        this.name = row.name;
        this.description = row.description;
        this.image = row.image;
        this.categoryName = row.categoryName;
        this.register = row.register;
        this.score = row.score;
        this.amount = row.amount;
      } else {
        this.tit = "添加";
        this.name = "";
        this.description = "";
        this.image = "";
        this.categoryName = "";
        this.register = "";
        this.score = "";
        this.amount = "";
      }
    },
    // 获取列表数据
    getShow(page) {
      this.loading = true;
      let data = {
        name: this.name1,
        categoryName: this.categoryName1,
        page: (page - 1) * 20
      }
      getScreenRoomList(data).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.ShowData = res.data.list;
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.count;
          return;
        } else {
          this.$Message({
            type: "info",
            message: res.msg
          })
        }
      })
    }
  }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/show/ScreenRoom.vue